import { useState } from 'react'
import { downloadTemplateFile, TEMPLATE_TYPE } from '@/services/downloadTemplateFile'
import { downloadCSVFiles } from '@/helpers/shadcn/utils'
import { FileTransferButton } from '@/components/organisms/FileTransferButton'
import { useIntl } from 'react-intl'
import { UploadResult } from '@/components/organisms/FileUploadWithModal/FileUploadWithModal'
import { useActiveTiers } from '@/containers/ClubPlus/hooks/useActiveTiers'

export const useTierList = () => {
  const { tiers, invalidateTiers } = useActiveTiers()
  const { formatMessage } = useIntl()

  const [isFileUploadModalOpen, setIsFileUploadModalOpen] = useState(false)
  const [formData, setFormData] = useState({})

  const handleFileUpload = (tierId) => {
    // Implement the logic to handle file upload once the backend is ready
    console.log('handleFileUpload::tierId', tierId)
    setIsFileUploadModalOpen(true)
  }

  const handleFileDownload = async (tierId, tierName) => {
    const data = { tierId, tierName, type: TEMPLATE_TYPE.TIER_CUSTOMERS, addStores: false }
    const response = await downloadTemplateFile(data)
    if (!response) return
    const fileName = `ClubPlus_${tierName}`
    downloadCSVFiles(response, fileName)
  }

  const handleModalDismiss = (uploadResult) => {
    setIsFileUploadModalOpen(false)
    if (uploadResult === UploadResult.SUCCESS) {
      invalidateTiers();
    }
  }

  // Table column configuration
  const getColumns = () => [
    {
      name_of_db_column: 'name',
      header: formatMessage({ id: 'CLUB_PLUS.TIER_LIST_TABLE_COLUMN_NAME' }),
    },
    {
      name_of_db_column: 'storesAssociated',
      header: formatMessage({ id: 'CLUB_PLUS.TIER_LIST_TABLE_COLUMN_NUMBER_OF_STORES' }),
    },
    {
      name_of_db_column: 'activities',
      header: formatMessage({ id: 'CLUB_PLUS.TIER_LIST_TABLE_COLUMN_ACTIVITIES_INCLUDED' }),
      cellData: ctx => {
        const activities = ctx?.row?.original?.activities
        return activities?.length ? (
          <ul className="list-disc space-y-1 pl-5">
            {activities.map(activity => (
              <li key={activity.activityID}>{activity.activityName}</li>
            ))}
          </ul>
        ) : null
      },
    },
    {
      name_of_db_column: 'status',
      header: formatMessage({ id: 'CLUB_PLUS.TIER_LIST_TABLE_COLUMN_STATUS' }),
    },
    {
      name_of_db_column: 'lastUpdated',
      header: formatMessage({ id: 'CLUB_PLUS.TIER_LIST_TABLE_COLUMN_LAST_UPDATED' }),
      cellData: ctx => {
        const lastUpdated = ctx?.row?.original?.lastUpdated
        if (!lastUpdated) return '-'
        return new Date(lastUpdated).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      },
    },
    {
      name_of_db_column: 'uploadStatus',
      header: formatMessage({ id: 'CLUB_PLUS.TIER_LIST_TABLE_COLUMN_UPLOAD_STATUS' }),
    },
    {
      header: formatMessage({ id: 'CLUB_PLUS.TIER_LIST_TABLE_COLUMN_UPLOAD' }),
      cellData: ctx => (<FileTransferButton isUpload onClick={() => handleFileUpload(ctx?.row?.original?.tierID)} />)
    },
    {
      header: formatMessage({ id: 'CLUB_PLUS.TIER_LIST_TABLE_COLUMN_DOWNLOAD' }),
      cellData: ctx => (<FileTransferButton onClick={() => handleFileDownload(ctx?.row?.original?.tierID, ctx?.row?.original?.name)} />)
    },
  ]

  return {
    tiers,
    getColumns,
    isFileUploadModalOpen,
    setIsFileUploadModalOpen,
    handleModalDismiss,
    setFormData,
    formData,
  }
}